import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import "./../assets/css/custom.css";

const SupplychainPackagelistHeadersEdit = () => {
  let { id } = useParams();

  const [contractlist, setContractlist] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [transportSuppliers, setTransportSuppliers] = useState([]);
  const [permission, setPermission] = useState({});
  const [locationLoading, setLocationLoading] = useState([]);

  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [orderLists, setOrderLists] = useState([]);
  const [value, setValue] = useState({});
  const [valueContents, setValueContents] = useState([]);

  const [packagingTypesLists, setPackagingTypesLists] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const [selectedlocations, setSelectedlocations] = useState([]);


  useEffect(() => {



    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));

          setLocationLoading(locations);

        } else {
          console.log("API response is not an array");
        }
      }).catch((error) => {
        console.log(error);
      });


    axios.post("/helpers/production_types_consumable", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.production_types;
        let productslisting = products.map((customer, index) => ({
          label: customer.consumable_name,
          value: customer.id,
          key: `address-${index}`,
        }));
        setPackagingTypesLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });




    setPermission(FindModuleById(91));
    axios.get(`/supply-chain-packaging-list-header/edit/${id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supply_chain_header);
          setValueContents(response.data.data.supply_chain_header.contents);
          setShowTableHeadings(true);
          let para = {
            contract: response.data.data.supply_chain_header.contract,
            order: response.data.data.supply_chain_header.order,
          }
          axios
            .post(`/multi-orders-by-contract-exist`, { para }, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              if (response.data.code === 200) {
                let orders = response.data.data.orders;
                let orderslisting = orders.map((customer, index) => ({
                  label: customer.po_number,
                  value: customer.id,
                  container_number: customer.container_number,
                  eta_date: customer.eta_date,
                  ship_address2: customer.ship_address2,
                  key: `address-${index}`,
                }));
                setOrderLists(orderslisting);
                const uniquePrices = [...new Map(
                  orders
                    .filter(order => order.price) // Remove empty prices
                    .map(order => [
                      order.price, // Use price as key for uniqueness
                      {
                        label: `${order.price}`, // Display label
                        value: order.price,
                        key: `price-${order.id}`,
                      }
                    ])
                ).values()];
                setPriceList(uniquePrices);

              } else {
                console.log("API response is not an array");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }).catch((error) => {
        console.log(error);
      });
  }, [id]);

useEffect(() => {
  console.log('get location in edit');
  console.log(value.location);
  // If value.location exists, set it as selected location
  if (value.location && value.location.length > 0) {
    const initialLocation = locationLoading.filter(
      loc => value.location.includes(loc.value)
    );
    setSelectedlocations(initialLocation);
  }
}, [locationLoading, value.location]);
  const formik = useFormik({
    initialValues: {

      id: value.id,


      location: value.location,
      order: value.order,
      contract: value.contract,
      container_number: value.container_number,
      seal_number: value.seal_number,
      shipping_line: value.shipping_line,
      date_of_loading: value.date_of_loading,
      total_net_weight: value.total_net_weight,
      total_brut_weight: value.total_brut_weight,
      eta: value.eta,

      expedition_date: value.expedition_date,
      tax: value.tax,
      remarks: value.remarks,
      items: valueContents,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/supply-chain-packaging-list-header/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Supply Chain Packaging");
          delete backendErrors['error'];
          //  actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/supplychain-package-lists";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console.log(error);
        });
    },
  });



  const getOrderDetail = (selectedOptions) => {
    // Handle empty selection
    if (!selectedOptions || selectedOptions.length === 0) {
      formik.setFieldValue('container_number', '');
      formik.setFieldValue('eta', '');
      return;  // ← Don't reset items, just clear these two fields
    }

    const lastOrder = selectedOptions[selectedOptions.length - 1];
    formik.setFieldValue('container_number', lastOrder.container_number || '');
    formik.setFieldValue('eta', lastOrder.eta_date || '');

    const currentItems = formik.values.items;

    // Items loaded from DB have no _order_id — NEVER touch these
    const dbItems = currentItems.filter(item => !item._order_id);
    const orderLinkedItems = currentItems.filter(item => item._order_id);

    // Map existing order-linked items by their order ID
    const existingItemsByOrder = {};
    orderLinkedItems.forEach(item => {
      existingItemsByOrder[item._order_id] = item;
    });

    // Only create NEW items for orders that don't already have an item
    const newOrderItems = selectedOptions
      .filter(order => !existingItemsByOrder[order.value])
      .map((order) => ({
        product: '',
        lot_number: '',
        bbd: '',
        packaging_type: '',
        number_of_boxes: '',
        price: order.price || '',
        net_weight: '',
        gross_weight: '',
        _order_id: order.value,
      }));

    // Remove items whose order was deselected
    const selectedOrderIds = selectedOptions.map(o => o.value);
    const keptOrderItems = orderLinkedItems.filter(item =>
      selectedOrderIds.includes(item._order_id)
    );

    // Final list = DB items (untouched) + kept order items + new order items
    const updatedItems = [...dbItems, ...keptOrderItems, ...newOrderItems];
    console.log(updatedItems);
    //formik.setFieldValue('items', updatedItems);
  };


  const getOrdersByContract = (selectedOptions) => {
    const contractIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];

    console.log("contractIds");
    console.log(contractIds);


    //   axios
    //     .post(`/multi-orders-by-contract-exist`, {para},{
    //       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    //     })

    let para = {
      contract: contractIds,
    }

    if (contractIds) {
      axios
        .post(`/multi-orders-by-contract-exist`, { para }, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let orders = response.data.data.orders;
            let orderslisting = orders.map((customer, index) => ({
              label: customer.po_number,
              value: customer.id,
              container_number: customer.container_number,
              price: customer.price,
              eta_date: customer.eta_date,
              ship_address2: customer.ship_address2,
              key: `address-${index}`,
            }));
            setOrderLists(orderslisting);

            const uniquePrices = [...new Map(
              orders
                .filter(order => order.price) // Remove empty prices
                .map(order => [
                  order.price, // Use price as key for uniqueness
                  {
                    label: `${order.price}`, // Display label
                    value: order.price,
                    key: `price-${order.id}`,
                  }
                ])
            ).values()];
            setPriceList(uniquePrices);

          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

  }
  useEffect(() => {

    axios
      .get(`/helpers/transport-supplier`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let transport_types = response.data.data.supplier;
          let transportlisting = transport_types.map((ord, index) => ({
            label: ord.name,
            value: ord.id,
            key: `supplier-${index}`,
          }));
          setTransportSuppliers(transportlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setPermission(FindModuleById(91));
    console.log(permission);

    axios
      .post(
        "/contracts/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.contracts;
          let orderslisting = orders.map((customer, index) => ({
            label: customer.contract_number,
            value: customer.id,
            key: `address-${index}`,
          }));
          setContractlist(orderslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios.post("/products/listing-category-type", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          // label: customer.name + " ("+customer.category.title+") "+ " ("+customer.type.title+")",
          label: customer.productname, value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });


  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };




  const inputStyle = {
    // Inline styles to remove the spinner in WebKit browsers
    WebkitAppearance: 'none',
    MozAppearance: 'textfield',
    margin: 0
  };

  const handleWheel = (event) => {
    // Prevent the default behavior of incrementing/decrementing on scroll
    event.preventDefault();
  };



  // Function to handle numeric input only, allowing decimal points
  const handleNumericInput = (event) => {
    const newValue = event.target.value;
    // const fieldName = event.target.name; // Get the name of the field

    // If the value is numeric or contains a decimal point, allow the input
    if (newValue === '' || /^[0-9\b]+(\.[0-9\b]*)?$/.test(newValue)) {
      formik.handleChange(event); // Use formik's handleChange to update the value
    } else {
      event.preventDefault(); // Prevent the default action if the input is invalid
    }
  };

  if (formik.values.items.length > 0) {
    // // Calculate total net weight and total gross weight
    // const totalNetWeight = formik.values.items.reduce((sum, item) => sum + (parseFloat(item.net_weight) || 0), 0);
    // const totalGrossWeight = formik.values.items.reduce((sum, item) => sum + (parseFloat(item.gross_weight) || 0), 0);
    // formik.setFieldValue('total_net_weight', totalNetWeight);
    // formik.setFieldValue('total_brut_weight', totalGrossWeight);
  }


  const calculateTotalWeight = (items, field) => {
    return items.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

   // 2. Fix handleSelectChangemulti — it's already correct once the call above is fixed
  const handleSelectChangemultiLocation = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("location", values);
    customHandleInput({ target: { name: "location", value: values } });
        setSelectedlocations(selectedOptions);

  };


  // 2. Fix handleSelectChangemulti — it's already correct once the call above is fixed
  const handleSelectChangemulti = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("contract", values);
    customHandleInput({ target: { name: "contract", value: values } });
  };

  // 2. Fix handleSelectChangemulti — it's already correct once the call above is fixed
  const handleSelectChangemultiOrder = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("order", values);
    customHandleInput({ target: { name: "order", value: values } });
  };

  console.log(locationLoading);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Supply Chain Packing List</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-package-lists">
                        Supply Chain Packing List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Packing List
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Packing List Header</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                          <div className="col-md-6">

                            <div className="form-group order status">
                              <label>Contract Number</label>
                              {contractlist.length > 0 && (
                                <Select
                                  name="contract"
                                  value={contractlist.filter(option =>
                                    Array.isArray(formik.values.contract) && formik.values.contract.includes(option.value)
                                  )}
                                  onChange={(selectedOptions) => {
                                    handleSelectChangemulti(selectedOptions);
                                    if (selectedOptions && selectedOptions.length > 0) {
                                      getOrdersByContract(selectedOptions);
                                    } else {
                                      setOrderLists([]);
                                    }
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={contractlist}
                                  placeholder="Select contract"
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                />
                              )}

                              <small>
                                {backendErrors.contract && (
                                  <span className="form-error mt-1">
                                    {backendErrors.contract}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Order</label>
                              <Select
                                name="order"
                                value={orderLists.filter(option =>
                                  Array.isArray(formik.values.order) && formik.values.order.includes(option.value)
                                )}
                               
                                onChange={(selectedOptions) => {
                                  handleSelectChangemultiOrder(selectedOptions);
                                  getOrderDetail(selectedOptions);

                                }}
                                onBlur={formik.handleBlur}
                                options={orderLists}
                                placeholder="Select Order"
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                              />

                              <small>
                                {backendErrors.order && (
                                  <span order="form-error mt-1">
                                    {backendErrors.order}
                                  </span>
                                )}
                              </small>
                            </div>

                            <div className="form-group">
                              <label>Seal Number</label>
                              <input
                                type="text"
                                className="form-input form-control"
                                name="seal_number"
                                value={formik.values.seal_number}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.seal_number && (
                                  <span className="form-error mt-1">
                                    {backendErrors.seal_number}
                                  </span>
                                )}
                              </small>
                            </div>



                            <div className="form-group">
                              <label>Date of Loading</label>
                              <input
                                type="date"
                                className="form-input form-control"
                                name="date_of_loading"
                                value={formik.values.date_of_loading}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.date_of_loading && (
                                  <span className="form-error mt-1">
                                    {backendErrors.date_of_loading}
                                  </span>
                                )}
                              </small>
                            </div>

                            <div className="form-group">
                              <label>ETA</label>
                              <input
                                type="date"
                                className="form-input form-control"
                                name="eta"
                                value={formik.values.eta}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.eta && (
                                  <span className="form-error mt-1">
                                    {backendErrors.eta}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>TAX</label>
                              <input
                                type="text"
                                className="form-input form-control"
                                name="tax"
                                value={formik.values.tax}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.tax && (
                                  <span className="form-error mt-1">
                                    {backendErrors.tax}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Remarks</label>
                              <textarea
                                type="remarks"
                                className="form-input form-control"
                                name="remarks"
                                value={formik.values.remarks}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);

                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.remarks && (
                                  <span className="form-error mt-1">
                                    {backendErrors.remarks}
                                  </span>
                                )}
                              </small>
                            </div>


                          </div>


                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Expedition Date</label>

                              <input
                                type="datetime-local"
                                name="expedition_date"
                                id="expedition_date"
                                value={formik.values.expedition_date}
                                className="form-input form-control input-error"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);

                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.expedition_date && (
                                  <span className="form-error mt-1">
                                    {backendErrors.expedition_date}
                                  </span>
                                )}
                              </small>
                            </div>

                            <div className="form-group">
                              <label>Location</label>

                              <Select
                            name="location"
                                  value={locationLoading.filter(option =>
                                    Array.isArray(formik.values.location) && formik.values.location.includes(option.value)
                                  )}
                                  onChange={(selectedOptions) => {
                                    handleSelectChangemultiLocation(selectedOptions);
                                    
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={locationLoading}
                                  placeholder="Select contract"
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                              />
                              <small>
                                {backendErrors.location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.location}
                                  </span>
                                )}
                              </small>
                            </div>


                            <div className="form-group">
                              <label>Container Number</label>
                              <input
                                type="text"
                                className="form-input form-control"
                                name="container_number"
                                value={formik.values.container_number}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}

                              />
                              <small>
                                {backendErrors.container_number && (
                                  <span className="form-error mt-1">
                                    {backendErrors.container_number}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Shipping Line</label>

                              <Select
                                className="w-100"
                                value={transportSuppliers.find(option => option.value == formik.values.shipping_line) || null} // Ensure correct format
                                name="shipping_line"
                                onChange={(selectedOption) => {
                                  handleSelectChange("shipping_line", selectedOption);

                                }}
                                onBlur={formik.handleBlur}
                                options={transportSuppliers}
                                placeholder="Select"


                              />
                              <small>
                                {backendErrors.shipping_line && (
                                  <span className="form-error mt-1">
                                    {backendErrors.shipping_line}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group">

                              <label>Total Net Weight</label>
                              <div className="input-group">
                                <input type="text"
                                  name="total_net_weight"
                                  value={formik.values.total_net_weight}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    handleNumericInput(e);
                                  }}
                                  onKeyPress={(event) => {
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  style={inputStyle} onWheel={handleWheel}
                                  onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Total Net Weight" aria-label="Total Net Weight" aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                  <span className="input-group-text" id="basic-addon2">KG</span>
                                </div>
                              </div>

                              <small>
                                {backendErrors.total_net_weight && (
                                  <span className="form-error mt-1">
                                    {backendErrors.total_net_weight}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Total Brut Weight</label>

                              <div className="input-group">
                                <input type="text"
                                  name="total_brut_weight"
                                  value={formik.values.total_brut_weight}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    handleNumericInput(e);
                                  }}
                                  onKeyPress={(event) => {
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                      event.preventDefault();
                                    }
                                  }}

                                  style={inputStyle} onWheel={handleWheel}
                                  onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Total Brut Weight" aria-label="Total Brut Weight" aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                  <span className="input-group-text" id="basic-addon2">KG</span>
                                </div>
                              </div>
                              <small>
                                {backendErrors.total_brut_weight && (
                                  <span className="form-error mt-1">
                                    {backendErrors.total_brut_weight}
                                  </span>
                                )}
                              </small>
                            </div>

                          </div>
                        </div>


                        <div id="new-production" >

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="items"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {

                                    let appendArr_1 = arrayHelpers.form.values.items && arrayHelpers.form.values.items[0];


                                    let initialArr = {

                                      product: (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "",
                                      lot_number: (appendArr_1 && appendArr_1.lot_number) ? appendArr_1.lot_number : "",
                                      bbd: (appendArr_1 && appendArr_1.bbd) ? appendArr_1.bbd : "",
                                      packaging_type: (appendArr_1 && appendArr_1.packaging_type) ? appendArr_1.packaging_type : "",
                                      number_of_boxes: (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "",
                                      price: (appendArr_1 && appendArr_1.price) ? appendArr_1.price : "",
                                      net_weight: (appendArr_1 && appendArr_1.net_weight) ? appendArr_1.net_weight : "",
                                      gross_weight: (appendArr_1 && appendArr_1.gross_weight) ? appendArr_1.gross_weight : "",


                                    }

                                    arrayHelpers.push(initialArr);


                                    setShowTableHeadings(true);
                                    console.log(arrayHelpers);
                                  }}
                                >
                                  +
                                </button>
                                <table>
                                  {showTableHeadings && (
                                    <thead>
                                      <tr>
                                        <td style={{ width: "12%" }}>Lot Number</td>
                                          {selectedlocations && selectedlocations.length  > 1 && (
                                          <td style={{ width: "12%" }}>Location</td>
                                      )} 
                                        <td style={{ width: "12%" }}>Product</td>
                                        <td style={{ width: "12%" }}>Packaging Type</td>
                                        <td style={{ width: "12%" }}>Number Of Boxes</td>
                                        <td style={{ width: "12%" }}>BBD</td>
                                        <td style={{ width: "12%" }}>Price</td>
                                        <td style={{ width: "12%" }}>Net Weight</td>
                                        <td style={{ width: "12%" }}>Gross Weight</td>
                                        <td style={{ width: "2%" }}></td>
                                      </tr>
                                    </thead>
                                  )}

                                  {formik.values.items.map((friend, index) => (
                                    <tbody key={index}>
                                      <tr key={index}>
                                        <td>
                                          <div className="form-group ">
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`items[${index}].lot_number`}
                                              value={formik.values.items[index].lot_number}
                                              placeholder="Lot Number"
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                         {selectedlocations && selectedlocations.length > 1 && (
                                            <td>
                                            <div className="form-group">
                                              <Select
                                                name={`items[${index}].item_location`}
                                                options={selectedlocations}
                                                value={selectedlocations.find(option => option.value == formik.values.items[index].item_location) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`items[${index}].item_location`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `items[${index}].item_location`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select"
                                                className="w-100"
  
  
                                              />
                                            </div>
                                          </td>
                                        )}
                                        <td>
                                          <div className="form-group">
                                            <Select
                                              name={`items[${index}].product`}
                                              options={productLists}
                                              value={productLists.find(option => option.value == formik.values.items[index].product) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`items[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `items[${index}].product`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"


                                            />
                                          </div>
                                        </td>

                                        <td>
                                          <div className="form-group ">
                                            <Select
                                              name={`items[${index}].packaging_type`}
                                              options={packagingTypesLists}
                                              value={packagingTypesLists.find(option => option.value == formik.values.items[index].packaging_type) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`items[${index}].packaging_type`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `items[${index}].packaging_type`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"

                                            />
                                          </div>
                                        </td>

                                        <td>
                                          <div className="form-group ">
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`items[${index}].number_of_boxes`}
                                              value={formik.values.items[index].number_of_boxes}
                                              placeholder="Boxes"
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group ">
                                            <input
                                              type="date"
                                              className="form-input form-control"
                                              name={`items[${index}].bbd`}
                                              value={formik.values.items[index].bbd}
                                              placeholder="BBD"
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>

                                        {/* <td>
                                            <div className="form-group">
                                            <div className="input-group">
                                            <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].price`}
                                                value={formik.values.items[index].price}
                                                onKeyPress={(event) => {
                                                  // Prevent non-numeric input for keypress
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Price"
                                              />
                                             
                                            </div>
                                              
                                            </div>
                                          </td> */}
                                        <td>
                                          <div className="form-group">
                                            <Select
                                              name={`items[${index}].price`}
                                              options={priceList}
                                              value={priceList.find(option => option.value == formik.values.items[index].price) || null}
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`items[${index}].price`, selectedOption ? selectedOption.value : '');
                                                customHandleInput({
                                                  target: {
                                                    name: `items[${index}].price`,
                                                    value: selectedOption ? selectedOption.value : '',
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select Price"
                                              className="w-100"
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].net_weight`}
                                                value={formik.values.items[index].net_weight}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                  // Calculate the total after the field value is fully updated
                                                  const updatedItems = [...formik.values.items];
                                                  updatedItems[index].net_weight = e.target.value;

                                                  formik.setFieldValue(
                                                    'total_net_weight',
                                                    calculateTotalWeight(updatedItems, 'net_weight')
                                                  );
                                                }}
                                                onKeyPress={(event) => {
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Net Weight"
                                                aria-label="Net Weight"
                                                aria-describedby="basic-addon2"
                                              />
                                              {/* <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">
                                                  KG
                                                </span>
                                              </div> */}
                                            </div>

                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].gross_weight`}
                                                value={formik.values.items[index].gross_weight}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                  // Calculate the total after the field value is fully updated
                                                  const updatedItems = [...formik.values.items];
                                                  updatedItems[index].gross_weight = e.target.value;

                                                  formik.setFieldValue(
                                                    'total_brut_weight',
                                                    calculateTotalWeight(updatedItems, 'gross_weight')
                                                  );
                                                }}
                                                onKeyPress={(event) => {
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Gross Weight"
                                                aria-label="Gross Weight"
                                                aria-describedby="basic-addon2"
                                              />
                                              {/* <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">
                                                  KG
                                                </span>
                                              </div> */}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <button
                                              className="btn btn-danger"
                                              type="button"
                                              onClick={() => arrayHelpers.remove(index)}
                                            >
                                              -
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))}
                                </table>


                              </div>
                            )}
                          />


                        </div>


                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                            Update Supply Chain Packaging
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplychainPackagelistHeadersEdit;
